import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { areResumeStatesEqual, RESUME_INITIAL_STATE } from './cost-to-build-client-ui-resume.state';
import type { ResumeState } from './cost-to-build-client-ui-resume.types';

const formatPrice = (value: number) =>
    new Intl.NumberFormat('fr-FR', { currency: 'EUR', maximumFractionDigits: 0, style: 'currency' }).format(value);

export const ResumeStore = signalStore(
    withState(RESUME_INITIAL_STATE),
    withComputed((store) => ({
        formattedPriceRange: computed(() => `${formatPrice(store.minPrice())} – ${formatPrice(store.maxPrice())}`),
        state: computed<ResumeState>(() => ({
            description: store.description(),
            maxPrice: store.maxPrice(),
            minPrice: store.minPrice(),
        })),
    })),
    withMethods((store) => {
        const setState = (patch: Partial<ResumeState>) => {
            const nextState: ResumeState = {
                ...store.state(),
                ...patch,
            };

            if (areResumeStatesEqual(store.state(), nextState)) {
                return;
            }

            patchState(store, patch);
        };

        return { setState };
    })
);
